import styled from 'styled-components';

const Container = styled.div`
        padding:10px 20px;
        font-size: 15px;
        
        .highlight
        {
            background-color: #ffff00;
        }

        `;

export default Container;